module.exports = __webpack_public_path__ + "img/solar-do-castelo.96bb22bd.jpg";